import Class from './c-flying-frame';
import './c-flying-frame@';

export default Class;